const routes = {
    login: "/",
    register: "/register",
    verifyOtp: "/verify-otp",
    forgotPassword: "/forgot-password",
    activateAccount: "/activate-account",
    resetPasswordConfirm:"/reset-password-confirm",
    completeProfile: "/complete-profile",
    fillPersonalDetails: "/fill-personal-details",
    dashboard: "/dashboard",
    recruits: "/recruits",
    commissions: "/commission-history",
    settings: "/profile-settings",
    notifications:"/notifications",
    support: "/support",
    supportTickets: "/support/tickets",
    supportHelp: "/support/help",
    faq: "/faq",
    helpTopics: "/help-topics",
    helpTopicDetails:"/help-topics/:topic_id",
    analytics: "/analytics",
    terms:"/terms-and-conditions",
    privacy:"/privacy-policy",
    termsAndPolicies:"/terms-and-policies",
    policyDetails:"/terms-and-policies/:id",
};

export default routes;